/**
 *  Format a number as a currency.
 *
 * @param {*} locale - What local should the returned number be
 * @param {*} decimals - Return decimals, true or false
 * @returns The formatted number
 */
export const formatCurrency = (locale = 'en-US', decimals = false) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: decimals ? 2 : 0,
    minimumFractionDigits: decimals ? 2 : 0,
  });
};

/**
 * Formats a number with commas and specified decimal places
 *
 * @param {number} number - The number to be formatted
 * @param {number} decimalPlaces - The number of decimal places (optional)
 * @returns {string} The formatted number as a string
 */
export function formatNumber(number, decimalPlaces = 0) {
  if (number == null) return '0';
  const options = {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  };
  return number && typeof number === 'string'
    ? parseFloat(number).toLocaleString(undefined, options)
    : number.toLocaleString(undefined, options);
}

export function formatItems(value) {
  const num = Number(value);
  return isNaN(num) ? '0' : num.toLocaleString('en-US');
}

export function roundWithPrecision(value, precision = 2) {
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}
